import { LoginType, MemberStatus } from '@lucidlink/dto/validation';
export const isPendingMember = (workspace, currentUser) => {
    return (workspace?.memberStatus === MemberStatus.PENDING &&
        currentUser?.loginType !== LoginType.VERIFICATION_CODE);
};
